import Icon, { IconSetClassicContext } from "./Icon";
import { IconSizes } from "./types";
export default Icon;
export { IconSizes, IconSetClassicContext };